import { animated } from 'react-spring';
import styled from 'styled-components';

export const AnimatedContainer = styled(animated.div)`
  display: flex;
  flex-direction: column;
`;
